import React from 'react';
import classnames from 'classnames';
import bulletItemStyle from './BulletItem.scss';
var BulletList = function (_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement("ul", { className: classnames(bulletItemStyle['list'], className) }, children));
};
BulletList.displayName = 'BulletList';
export default BulletList;
//# sourceMappingURL=BulletList.js.map